import {
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import PlanCodeDialogue from 'ApplicationEntry/components/WorkFlow/PlanCodes/PlanCodeDialogue';
import ProductRiders from 'ApplicationEntry/components/WorkFlow/ProductsRiders/ProductsRiders';
import * as PCI from 'ApplicationEntry/ducks/planCode';
import * as PC from 'ApplicationEntry/ducks/planCodes';
import {clearAccident} from 'ApplicationEntry/ducks/ProductsRiders/accident';
import {clearAIP} from 'ApplicationEntry/ducks/ProductsRiders/aip';
import {clearCancer} from 'ApplicationEntry/ducks/ProductsRiders/cancer';
import {clearCriticalIllness} from 'ApplicationEntry/ducks/ProductsRiders/criticalIllness';
import {clearDisability} from 'ApplicationEntry/ducks/ProductsRiders/disability';
import {clearHeartStroke} from 'ApplicationEntry/ducks/ProductsRiders/heartStroke';
import {clearShop} from 'ApplicationEntry/ducks/ProductsRiders/shop';
import {clearUniversalLife} from 'ApplicationEntry/ducks/ProductsRiders/universalLife';
import {InvalidApplication, ValidApplication} from 'ApplicationEntry/models/Application';
import {ApplicationModeType} from 'ApplicationEntry/models/ApplicationModeType';
import {ProductRiderGroups, ProductsRidersPolicyType} from 'ApplicationEntry/models/ProductsRiders/Families';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import ModularHost from 'Shared/components/ModularHost/ModularHost';
import ActionsMenu from 'Shared/components/PagedView/ActionsMenu';
import ToolbarHeader from 'Shared/components/Toolbar/ToolbarHeader';
import './PlanCodeSection.sass';

type PlanCodeSectionProps = {
  application: InvalidApplication | ValidApplication;
  mode: ApplicationModeType;
};

const PlanCodeSection = (props: PlanCodeSectionProps) => {
  const dispatch = useDispatch();

  const planCodeItems = props.application.planCodes.planCodes;
  const planCodeItem = props.application.planCode;
  const replaceProduct = props.application.planCodes.replaceProduct;

  const selectedPolicyType =
    props.application.caseDetails.productType.key === 'LoadedPolicyTypes'
      ? props.application.caseDetails.productType.selectedPolicyTypes
      : [];

  const [dialogOpen, setDialogueOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [planSelected, changePlanSelected] = useState('');
  const [planDetailsLabel, setPlanDetailsLabel] = useState<HTMLLabelElement | null>();

  const handleClickOpen = (index: number) => {
    const item = planCodeItems[index];
    dispatch(PCI.editPlanCode(item.phase, item.tracInputL70, item.units, item.description, item.onTheJobRiderBenefit));
    setSelectedIndex(index);
    setDialogueOpen(true);
  };

  const handleClose = () => {
    setDialogueOpen(false);
  };

  const handleChangePlan = (checked: boolean) => {
    dispatch(PC.replaceProduct(checked));
    if (!checked) {
      changePlanSelected('');

      const selectedPolicyList =
        props.application.caseDetails.productType.key === 'LoadedPolicyTypes'
          ? props.application.caseDetails.productType.selectedPolicyTypes
          : [];

      selectedPolicyList.forEach(selectedPolicy => {
        switch (selectedPolicy.family?.name?.toLowerCase()) {
          case ProductRiderGroups[ProductsRidersPolicyType.Accident].toLowerCase():
            dispatch(clearAccident());
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.Cancer].toLowerCase():
            dispatch(clearCancer());
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness].toLowerCase():
            dispatch(clearCriticalIllness());
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.Disability].toLowerCase():
            dispatch(clearDisability());
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.HeartStroke].toLowerCase():
            dispatch(clearHeartStroke());
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.Shop].toLowerCase():
            dispatch(clearShop());
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.UniversalLife].toLowerCase():
            dispatch(clearUniversalLife());
            break;
          case ProductRiderGroups[ProductsRidersPolicyType.Aip].toLowerCase():
            dispatch(clearAIP());
            break;
        }
      });
    }
  };

  return (
    <div className="plan-Code-section__head">
      <ModularHost>
        <ToolbarHeader title="Plan Codes" />
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Phase</TableCell>
                <TableCell>Plan Code</TableCell>
                <TableCell>Units</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {planCodeItems.map((item, index) => (
                <TableRow key={index}>
                  <TableCell component="th" scope="row">
                    {item.phase}
                  </TableCell>
                  <TableCell>{item.planCode}</TableCell>
                  <TableCell>{item.units}</TableCell>
                  <TableCell>{item.description}</TableCell>
                  <TableCell id="plan-code-table-actions">
                    <ActionsMenu>
                      <MenuItem
                        id="plan-code-table-actions-edit"
                        key="plan-code-edit"
                        onClick={() => handleClickOpen(index)}
                      >
                        Edit
                      </MenuItem>
                    </ActionsMenu>
                  </TableCell>
                </TableRow>
              ))}

              <TableRow>
                <TableCell>Item Count:</TableCell>
                <TableCell>{planCodeItems.length}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </ModularHost>

      <form noValidate autoComplete="off">
        <div className="plan-Code-section__view-form-row">
          <Grid container direction="row" justify="flex-start" alignItems="center">
            <Grid item xs={3}>
              <FormControlLabel
                className="plan-Code-section__view-form-text-field"
                control={
                  <Checkbox
                    checked={replaceProduct}
                    onChange={e => handleChangePlan(e.target.checked)}
                    name="checkedB"
                    color="secondary"
                  />
                }
                label={<Typography>Change Plan Details</Typography>}
              />
            </Grid>
            <Grid item xs={3}>
              <FormControl variant="outlined" className="plan-Code-section__view-form-text-field">
                <InputLabel ref={setPlanDetailsLabel} id="plan-code-policy-label">
                  Policy
                </InputLabel>
                <Select
                  labelId="plan-code-label-policy"
                  labelWidth={planDetailsLabel?.clientWidth}
                  id="plan-code-policy"
                  value={planSelected}
                  onChange={e => changePlanSelected(e.target.value as string)}
                  displayEmpty
                  disabled={!replaceProduct}
                >
                  {selectedPolicyType.map(policy => (
                    <MenuItem key={policy?.productGroup!} value={policy?.productGroup!}>
                      {policy?.name!}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </div>
      </form>
      {planSelected !== '' ? (
        <ProductRiders application={props.application} mode={props.mode} />
      ) : (
        <Divider className="application-form__actions-divider" />
      )}
      <PlanCodeDialogue
        dialogOpen={dialogOpen}
        dialogClose={handleClose}
        index={selectedIndex}
        planCodeItem={planCodeItem}
      />
    </div>
  );
};

export default PlanCodeSection;
